// Shared decoded-tile cache so the barbs layer and the speed-fill layer each
// fetch + canvas-decode a given uv tile only ONCE. Keyed by full URL. Small LRU
// bound keeps memory in check (a handful of MB). Browser-only (uses canvas).

const CACHE = new Map(); // url -> { w, h, data }  (insertion order = LRU)
const INFLIGHT = new Map(); // url -> Promise<{w,h,data}|null>
const MAX = 48;

async function decode(url, signal) {
  const resp = await fetch(url, { signal });
  if (!resp.ok) return null;
  const bmp = await createImageBitmap(await resp.blob());
  const w = bmp.width, h = bmp.height; // read BEFORE close() — a closed bitmap reports 0
  const canvas = document.createElement('canvas');
  canvas.width = w; canvas.height = h;
  const ctx = canvas.getContext('2d', { willReadFrequently: true });
  ctx.drawImage(bmp, 0, 0);
  bmp.close && bmp.close();
  return { w, h, data: ctx.getImageData(0, 0, w, h).data };
}

// Returns {w,h,data} or null. Concurrent callers for the same url share one fetch.
export async function getDecodedTile(url, signal) {
  const hit = CACHE.get(url);
  if (hit) { CACHE.delete(url); CACHE.set(url, hit); return hit; } // bump LRU
  if (INFLIGHT.has(url)) return INFLIGHT.get(url);
  const p = decode(url, signal)
    .then((tile) => {
      INFLIGHT.delete(url);
      if (tile) {
        CACHE.set(url, tile);
        while (CACHE.size > MAX) CACHE.delete(CACHE.keys().next().value);
      }
      return tile;
    })
    .catch((e) => { INFLIGHT.delete(url); throw e; });
  INFLIGHT.set(url, p);
  return p;
}
